import React, { JSX } from "react";

import css from "./columns.module.scss";

type ReportNameColumnProps = {
  reportName: string;
};

export const ReportNameColumn = ({ reportName }: ReportNameColumnProps): JSX.Element => (
  <div className={css.reportNameCell}>{reportName}</div>
);
